import { AirtableAttachment } from '../../../../../types';

export default function downloadAll(attachments?: AirtableAttachment[]) {
  if (attachments) {
    attachments.forEach(async (attachment) => {
      // prior fetch prevents opening new tabs
      const attachmentStored = await fetch(attachment.url);
      const attachmentBlob = await attachmentStored.blob();
      const localAttachmentUrl = URL.createObjectURL(attachmentBlob);

      const link = document.createElement('a');

      link.href = localAttachmentUrl;
      link.download = attachment.filename;
      link.click();
      // free memory
      URL.revokeObjectURL(localAttachmentUrl);
    });
  }
}
